export const redirectToLogin = () => {
  const here = window.location.href;
  const redirectQueryParams = new URLSearchParams();
  redirectQueryParams.set('redirect-to', here);
  const signInLocation = `/login?${redirectQueryParams.toString()}`;
  window.location.assign(signInLocation);
};
